import { Loading } from "@nextui-org/react";

export default function ButtonLoader() {
  return <Loading type="points-opacity" color="success" />;
}
